export default __webpack_public_path__ + "static/media/updatePhoto-approved.a4060389.svg";